export function getMacStageName(macStage: 0 | 1 | 2 | 3 | 4): string {
    switch (macStage) {
        case 0:
            return '-';
        case 1:
            return 'Inception';
        case 2:
            return 'Adoption';
        case 3:
            return 'Proliferation';
        case 4:
            return 'Ubiquity';
        default:
            return '-';
    }
}